import { TextboxComponent } from "../textbox.component";
import { GISConfig, GISOptions, ensureOptionsExist } from "../../../../gis/models/gis-config.model";
import { TextboxController } from "./textbox-controller.interface";
import { GISControllerService } from "../../../services/GIS-controller.service";
import { WellConfigurationIndex } from "../../new-casing-plan/models/casing-plan.model";
import { debounceTime } from "rxjs/operators";
import { deepClone } from "../../../../builder/models/editor.model";

export class GISController implements TextboxController {
    component: TextboxComponent;
    config: GISConfig;
    _options: GISOptions;

    get options() { return this._options; }

    constructor(
        readonly service: GISControllerService
    ) {
        this.config = window["GIS.Conf"] as GISConfig;
    }

    onInit(): void {
        /**
         * When X, Y, or stateplane values change we must clear the generated GIS data from this information
         * */
        if (this.component.enableEditing) {

            let contextTarget = this.component.componentData.contextTarget;
            let x = this.service.getContextTarget(WellConfigurationIndex.LongitudeDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.LongitudeHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.LongitudeVertical, this.options);
            
            let y = this.service.getContextTarget(WellConfigurationIndex.LatitudeDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.LatitudeHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.LatitudeVertical, this.options);

            let plane = this.service.getContextTarget(WellConfigurationIndex.StatePlaneDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.StatePlaneHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.StatePlaneVertical, this.options);

            let lat = this.service.getContextTarget(WellConfigurationIndex.LatitudeNumeric, this.options);
            let long = this.service.getContextTarget(WellConfigurationIndex.LongitudeNumeric, this.options);


            if (x === contextTarget || y === contextTarget || plane === contextTarget || lat === contextTarget || long === contextTarget) {
                let previous = deepClone(this.service.contextService.getContextData(`${contextTarget}.value`, this.component.componentContext));                
                this.component.control.valueChanges.pipe(debounceTime(1000)).subscribe((data) => {
                    if (previous !== "" && data !== previous) {
                        previous = data;
                        this.service.clear(this.options);
                    }                   
                });
            }
        }
    }

    afterViewInit() {
        if (this.component.enableEditing) {

            //Attempt to execute the query on initialization if the fields are set
            this.queryCoordinates();
        }
    }

    blur(): void {
        this.change();
    }

    setup(args: any) {
        this._options = ensureOptionsExist(args);
    }

    queryCoordinates(): void {
        this.service.context = this.component.componentContext;
        this.service.loader.toggleLoader(true);
        try {
            this.service.queryCoordinates(this.options, this.config).then(result => {
                this.service.loader.toggleLoader(false);
            }, (rej) => {
                this.service.loader.toggleLoader(false);
            });
        } catch (error) {
            console.error(error);
            this.service.loader.toggleLoader(false);
        }

       
    }

    change(): void {
        if (this.component && this.component.componentData && this.component.enableEditing)
            this.queryCoordinates();
    }
}

